import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  standalone: true,
  imports: [RouterLink],
  selector: 'lib-pending-task-card',
  host: {
    class: 'block h-full',
  },
  template: `
    <a
      class="grid h-full gap-2 rounded-md border border-gray-100 bg-white px-3 py-2.5 transition-colors hover:border-orange-200 hover:bg-orange-50"
      [routerLink]="route()"
    >
      <ng-content />
    </a>
  `,
})
export class PendingTaskCardComponent {
  route = input.required<readonly (string | number)[]>();
}
